module.exports = __webpack_public_path__ + "static/media/brinquedo5.d6c94210.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brinquedo5.jpg
// module id = 61
// module chunks = 0